module.exports = __webpack_public_path__ + "static/img/cp-1.45f6c1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/cp-1.jpg
// module id = CLhD
// module chunks = 52